// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const Description = ({ classes, text }) => (
  <div className={classes.mainContainer}>
    <span className={classes.text}>{text}</span>
  </div>
);

Description.propTypes = {
  classes: PropTypes.any,
  text: PropTypes.string,
};

Description.defaultProps = {
  classes: {},
  text: 'no text',
};

export default withStyles(styles)(Description);
